'use client';

import { AuthorBox, AuthorBoxVariant } from '@/components/magazine/AuthorBox';
import { useOptionalRenderContext } from '@/lib/render/RenderContextProvider';

/**
 * The author's biography, at the position an editor gave this block on the
 * author Template Page (spec 10.02.06 § AC 2–3).
 *
 * Everything it shows — the `Über {die Autorin|den Autor}` heading, the
 * portrait, the name, the subtitle and the rich-text description — is
 * `AuthorBox`'s profile branch; this block contributes only the page's width
 * wrapper, which the reference design gives the box and which belongs to the
 * block rather than to the route (10.03.02.02.05 § AC 2).
 *
 * The block is allowed on an article Template Page too, where the render
 * context carries that article's author (10.03.02.02.05 § OOS's two page
 * types). That is the one thing it does inspect the context for: an author
 * page carries no article, and only there is the author's name the page's
 * `<h1>`. On an article page the `<h1>` is the article title, which the route
 * renders, so the box drops to `h3` rather than emitting a second one.
 */
export const MagazineAuthorPageHeaderComponent = () => {
  const ctx = useOptionalRenderContext();

  // Inert on any other Page, and empty in a Template Page preview: no other
  // route puts an author in the render context.
  if (!ctx?.entities.author) {
    return null;
  }

  return (
    // `pt-12`: the profile is the first section under the sticky header,
    // which would otherwise sit directly on the heading.
    <div className="pt-12 pb-6">
      <AuthorBox
        author={ctx.entities.author}
        variant={AuthorBoxVariant.Profile}
        nameHeading={ctx.entities.article ? 'h3' : 'h1'}
      />
    </div>
  );
};
